import { POI_ACTION_TYPES } from '../actionTypes';

// reducer with initial state
const initialState = {
  poi_list: [],
  context_data: {},
  search_response: {},
  selected_poi: {},
  more_info: {},
  route: {},
  routes_list: [],
  route_inprogress: false,
  single_poi: false,
  poi_list_inprogress: false,
  routes_loading: false,
  routes_error: null,
  poi_loading: false,
  poi_error: null,
  waypointPOI: {},
  stops_inprogress: false,
  stops: {},
  number_of_stops: 0,
  incoming_stop: {},
  favorite_recent_list: [],
  favorite_recent_loading: false,
  favorite_recent_error: null,
  edit_list_inprogress: false,
  favorite_list_inprogress: false,
  recent_list_inprogress: false,
  quicklinks_inprogress: false,
  quickLinks_error: null,
  quickLinks_loading: false,
  turnbyturn_loading: false,
  turnbyturn_error: null,
  summary: '',
  turnbyturn_routes: [],
  filtered_list: [],
  filter_criteria_list: {
    rating: '*',
    price: '*',
    openNow: false,
  },
};

const poiReducer = (state = initialState, action) => {
  let newCriteria;
  switch (action.type) {
    case POI_ACTION_TYPES.POI_RESET:
      return {
        poi_list: [],
        context_data: {},
        search_response: {},
        selected_poi: {},
        more_info: {},
        route: {},
        routes_list: [],
        route_inprogress: false,
        single_poi: false,
        poi_list_inprogress: false,
        routes_loading: false,
        routes_error: null,
        poi_loading: false,
        poi_error: null,
        waypointPOI: {},
        stops_inprogress: false,
        stops: {},
        number_of_stops: 0,
        incoming_stop: {},
        favorite_recent_list: [],
        favorite_recent_loading: false,
        favorite_recent_error: null,
        edit_list_inprogress: false,
        favorite_list_inprogress: false,
        recent_list_inprogress: false,
        quicklinks_inprogress: false,
        quickLinks_error: null,
        quickLinks_loading: false,
        turnbyturn_loading: false,
        turnbyturn_error: null,
        summary: '',
        turnbyturn_routes: [],
        filtered_list: [],
        filter_criteria_list: {
          rating: '*',
          price: '*',
          openNow: false,
        },
      };
    case POI_ACTION_TYPES.GET_POI_INFORMATION.LOADING:
      return { ...state, poi_loading: true, more_info: {}, poi_error: null };
    case POI_ACTION_TYPES.GET_POI_INFORMATION.SUCCESS:
      return { ...state, poi_loading: false, more_info: action.payload, poi_error: null };
    case POI_ACTION_TYPES.GET_POI_INFORMATION.ERROR:
      return {
        ...state,
        poi_loading: false,
        more_info: null,
        poi_error: action.error,
      };
    case POI_ACTION_TYPES.POI_FROM_WS.SUCCESS:
      return {
        ...state,
        poi_loading: false,
        context_data: action.payload.contextData,
        poi_list: action.payload.locations,
        search_response: {
          searchCategory: action.payload.searchCategory,
          sortCriteria: action.payload.sortCriteria,
          title: action.payload.title,
          totalCount: action.payload.totalCount,
        },
      };
    case POI_ACTION_TYPES.FILTER.SAVE_LIST:
      return {
        ...state,
        filtered_list: action.payload.filteredList,
      };
    case POI_ACTION_TYPES.FILTER.SET:
      newCriteria = { ...state.filter_criteria_list };
      newCriteria[action.payload.criteriaName] = action.payload.value;
      return {
        ...state,
        filter_criteria_list: newCriteria,
      };
    case POI_ACTION_TYPES.INCOMING_STOP:
    case POI_ACTION_TYPES.POI_SELECTED.LOADING:
      return {
        ...state,
        poi_loading: false,
        poi_error: null,
        incoming_stop: action.payload.poiData
          ? { ...state.incoming_stop, ...action.payload.poiData }
          : { ...state.incoming_stop, ...action.payload },
        selected_poi: action.payload.poiData
          ? { ...state.selected_poi, ...action.payload.poiData }
          : { ...state.selected_poi, ...action.payload },
        context_data: action.payload.contextData
          ? { ...state.context_data, ...action.payload.contextData }
          : state.context_data,
        destination: action.payload.destination
          ? { ...state.destination, ...action.payload.destination }
          : state.destination,
        number_of_stops: action.payload.numberOfStops
          ? { ...state.number_of_stops, ...action.payload.numberOfStops }
          : state.number_of_stops,
        route: action.payload.route ? { ...state.route, ...action.payload.route } : state.route,
      };
    case POI_ACTION_TYPES.ALTERNATE_ROUTE:
      return {
        ...state,
        routes_error: null,
        routes_loading: false,
        route: action.payload,
      };
    case POI_ACTION_TYPES.ROUTES_LIST_FROM_WS.SUCCESS:
      return {
        ...state,
        routes_error: null,
        routes_loading: false,
        routes_list: action.payload.routes,
      };
    case POI_ACTION_TYPES.ROUTE_WAYPOINT_DETAILS.SUCCESS:
      return {
        ...state,
        poi_loading: false,
        poi_error: null,
        selected_poi: action.payload.destination
          ? { ...state.selected_poi, ...action.payload.destinationPOI }
          : { ...state.selected_poi, ...action.payload.destinationPOI },
        route: action.payload.route ? { ...state.route, ...action.payload.route } : state.route,
        waypointPOI: action.payload.waypointPOI
          ? { ...state.waypointPOI, ...action.payload.waypointPOI }
          : state.waypointPOI,
      };
    case POI_ACTION_TYPES.NAVIGATION_STATE.ROUTE_INPROGRESS:
      return {
        ...state,
        route_inprogress: action.payload,
      };
    case POI_ACTION_TYPES.NAVIGATION_STATE.SINGLE_POI:
      return {
        ...state,
        single_poi: action.payload,
      };
    case POI_ACTION_TYPES.NAVIGATION_STATE.POI_LIST_INPROGRESS:
      return {
        ...state,
        poi_list_inprogress: action.payload,
      };
    case POI_ACTION_TYPES.NAVIGATION_STATE.ADD_STOP_INPROGRESS:
      return {
        ...state,
        stops_inprogress: action.payload,
      };
    case POI_ACTION_TYPES.NAVIGATION_STATE.EDIT_LIST_INPROGRESS:
      return {
        ...state,
        edit_list_inprogress: action.payload,
      };
    case POI_ACTION_TYPES.NAVIGATION_STATE.FAVORITE_LIST_INPROGRESS:
      return {
        ...state,
        favorite_list_inprogress: action.payload,
      };
    case POI_ACTION_TYPES.NAVIGATION_STATE.RECENT_LIST_INPROGRESS:
      return {
        ...state,
        recent_list_inprogress: action.payload,
      };
    case POI_ACTION_TYPES.NAVIGATION_STATE.QUICKLINKS_INPROGRESS:
      return {
        ...state,
        quicklinks_inprogress: action.payload,
      };
    case POI_ACTION_TYPES.STOPS:
      return {
        ...state,
        stops: action.payload.poiData
          ? { ...state.stops, ...action.payload.poiData }
          : { ...state.stops, ...action.payload },
        context_data: action.payload.contextData
          ? { ...state.context_data, ...action.payload.contextData }
          : state.context_data,
        destination: action.payload.destination
          ? { ...state.destination, ...action.payload.destination }
          : state.destination,
        number_of_stops: action.payload.numberOfStops
          ? { ...state.number_of_stops, ...action.payload.numberOfStops }
          : state.number_of_stops,
        route: action.payload.route ? { ...state.route, ...action.payload.route } : state.route,
      };
    case POI_ACTION_TYPES.REMOVE_STOPS:
      return {
        ...state,
        stops: {},
        incoming_stop: {},
      };
    case POI_ACTION_TYPES.RECENT_LIST_FROM_WS.SUCCESS:
    case POI_ACTION_TYPES.FAVORITE_LIST_FROM_WS.SUCCESS:
      return {
        ...state,
        favorite_recent_error: null,
        favorite_recent_loading: false,
        favorite_recent_list: action.payload.locations,
        search_response: {
          searchCategory: action.payload.searchCategory,
          sortCriteria: action.payload.sortCriteria,
          title: action.payload.title,
          totalCount: action.payload.totalCount,
        },
      };
    case POI_ACTION_TYPES.QUICKLINKS_FROM_WS.SUCCESS:
      return {
        ...state,
        quickLinks_error: null,
        quickLinks_loading: false,
        context_data: action.payload.contextData
          ? { ...state.context_data, ...action.payload.contextData }
          : state.context_data,
      };
    case POI_ACTION_TYPES.TURN_BY_TURN_FROM_WS.SUCCESS:
      return {
        ...state,
        turnbyturn_error: null,
        turnbyturn_loading: false,
        summary: action.payload.summary,
        turnbyturn_routes: action.payload.routes,
      };
    default:
      return state;
  }
};

export default poiReducer;
